<template>
  <g :transform="transform" :class="getArrowClass" :data-start="dataStart">
    <circle
      :cx = 0
      :cy = 0
      r = "13"
      :fill = fill
      fill-opacity = ".7"
      pointer-events="visible"
      :id=id
    />
    <g transform="translate(-14.25,-16), scale(1.5)">
      <circle cx="9.5" cy="10.72" r="6.5" :fill="getCircleFill" filter="url(#drop-shadow-1)" />
      <g transform="translate(4.75,6)" v-if="showArrows">
        <polygon v-if="direction === 'ew' || direction === 'all'" points="8.64 3.74 7.51 2.61 6.35 3.77 7.48 4.9 6.35 6.03 7.51 7.19 8.64 6.06 9.8 4.9 8.64 3.74" :fill="getArrowFill" stroke-width="0"/>
        <polygon v-if="direction === 'ew' || direction === 'all'" points="2.32 4.9 3.45 3.77 2.29 2.61 1.16 3.74 0 4.9 1.16 6.06 2.29 7.19 3.45 6.03 2.32 4.9" :fill="getArrowFill" stroke-width="0"/>
        <polygon v-if="direction === 'ns' || direction === 'all'" points="4.9 7.48 3.77 6.35 2.61 7.51 3.74 8.64 4.9 9.8 6.06 8.64 7.19 7.51 6.03 6.35 4.9 7.48" :fill="getArrowFill" stroke-width="0"/>
        <polygon v-if="direction === 'ns' || direction === 'all'" points="4.9 2.32 6.03 3.45 7.19 2.29 6.06 1.16 4.9 0 3.74 1.16 2.61 2.29 3.77 3.45 4.9 2.32" :fill="getArrowFill" stroke-width="0"/>
      </g>
    </g>
  </g>
</template>

<script>
import { useSegmentStore } from '@/store/SegmentStore';

export default {
  name: 'EWArrows',
  props: [
    'circle',
    'fill',
    'id',
    'transform',
    'mouseDown',
    'direction',
    'offset',
    'num',
    'dataStart'
  ],
  computed: {
    showArrows () {
      return useSegmentStore().getInletIndex !== this.$props.num;
    },
    getArrowClass () {
      if (this.$props.direction === 'ew') {
        return 'ew';
      } else if (this.$props.direction === 'ns') {
         return 'ns';
      } else {
        return 'all';
      }
    },
    getArrowFill () {
      return (!this.$props.offset) ? '#707070' : 'white';
    },
    getCircleFill () {
      return (!this.$props.offset) ? 'white' : '#707070';
    }
  },
  methods: {
    handleMouseDown (e) {
      this.$props.mouseDown(e);
    }
  }
};
</script>

<style scoped>
.ew {
  cursor: ew-resize;
}
.ns {
  cursor: ns-resize;
}
.all {
  cursor: move;
}
</style>